export const mplaceAppUrls = {
    iOS: "https://itunes.apple.com/us/app/mplace/id1031890542?ls=1&mt=8",
    android: "https://play.google.com/store/apps/details?id=io.mplace"
};

export const staftrAppUrls = {
    iOS: "https://apps.apple.com/us/app/staftr/id6739492335",
    android: "https://play.google.com/store/apps/details?id=com.staftr.app"
};

export const pwcAppUrls = {
    iOS: "https://itunes.apple.com/us/app/mplace/id6745400402?ls=1&mt=8",
    android: 'https://play.google.com/store/apps/details?id=com.pwcandroid.app' 
};